/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___   
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _| 
 | |_| | | | | |_) || |  / / | | |  \| | | | | || | 
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___|
                                                                                                                                                                                                                                                                                                                                       
=========================================================
* Horizon UI - v1.1.0
=========================================================

* Product Page: https://www.horizon-ui.com/
* Copyright 2023 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Chakra imports
import {
  Alert,
  AlertIcon,
  Box,
  Stack,
  FormLabel,
  Button,
  Select,
  Card,
  CardHeader,
  CardBody,
  Text,
  Heading,
  SimpleGrid,
  Input,
  useColorModeValue,
} from "@chakra-ui/react";
// Assets
import React, { useState } from "react";
import {
  MdAddTask,
  MdAttachMoney,
  MdBarChart,
  MdFileCopy,
} from "react-icons/md";

export default function UserReports() {
  // Chakra Color Mode
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const {responseMessage, setResponsemessage} = useState("");
  const {responseCode, setResponseCode} = useState();

  const createOrganization = () => {
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-RapidAPI-Key': 'your-api-key',
        'X-RapidAPI-Host': 'jokes-by-api-ninjas.p.rapidapi.com',
      },
      body: JSON.stringify("")
    };

    fetch('https://api.beehiveproject.no/organization', options)
      .then(response => response.json())
      .then(data => console.log(data))
      .catch(error => console.error(error));
  }

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>

      <SimpleGrid columns={{ base: 1, md: 2, xl: 1 }} gap='20px' mb='20px'>   
      <SimpleGrid columns={{ base: 1, md: 2, xl: 2 }} gap='20px'>
        <Select variant='filled' placeholder='Organization'>
            <option value='Vikkilen'>Vikkilen</option>
            <option value='Revehiet'>Beehive Barnehage</option>
            <option value='Sneglehuset'>Test</option>
          </Select>
          <Select variant='filled' placeholder='Department'>
            <option value='Vikkilen'>Vikkilen</option>
            <option value='Sneglehuset'>Test</option>
          </Select>
      </SimpleGrid>
      <SimpleGrid columns={{ base: 1, md: 2, xl: 2 }} gap='20px' mb='20px'>
        <Select variant='filled' placeholder='Chips'>
            <option value='Vikkilen'>1</option>
            <option value='Revehiet'>2</option>
            <option value='Sneglehuset'>3</option>
          </Select>
      </SimpleGrid>
        <Box background={"gray"} height={"70vh"}>
          <Text>This is some test logging text</Text>
        </Box>   
      </SimpleGrid>

    </Box>
  );
}
